<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 w-screen"
    aria-modal="true"
    role="dialog"
  >
    <div class="flex items-center min-h-screen justify-center">
      <div
        class="rounded-xl shadow-lg w-[300px] md:w-[400px] bg-white py-6 px-4 flex flex-col justify-center items-center font-poppins"
      >
        <!-- Icon -->
        <div
          class="rounded-full w-20 h-20 flex justify-center items-center bg-[#FCB040] animate-pulse"
        >
          <icon
            name="exclamationmark1"
            class="w-16 h-16 text-white flex justify-center items-center"
          />
        </div>

        <!-- Title -->
        <h1 class="text-[14px] md:text-[14px] font-semibold mt-4 text-center">
          We’re still working on this system to serve you better.
        </h1>
        <p class="mt-1 text-[12px] md:text-[13px]">
          In the meantime, please choose another system to use.
        </p>
        <!-- Break Line -->
        <div class="w-full h-[1px] rounded-md bg-gray-200 mt-4"></div>
        <!-- Buttons -->
        <div class="tracking-wide flex gap-2 mt-4">
          <button
            class="bg-green1 p-2 px-3 text-[11px] md:text-[13px] rounded-md text-white hover:bg-white border hover:border-green1 hover:text-green1 hover:shadow-md"
            @click="closeModal"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../icon.vue";

export default {
  name: "OngoingPage",
  components: {
    icon,
  },

  data() {
    return {
      isOpen: true,
    };
  },

  methods: {
    closeModal() {
      this.isOpen = false;
      this.$emit("close");
    },
  },
};
</script>
